import { useContext, useState } from 'react'
import { AuthContext } from '../../../../contexts/AuthContext'

type HookTypes = {
  endpoint: string
  onSuccess: (resp: any) => void
  extraData?: any
}

const useSubmit = ({ endpoint, onSuccess, extraData = {} }: HookTypes) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [serverError, setServerError] = useState<string>('')
  const { instance } = useContext<any>(AuthContext)

  const onSubmit = async (formData: any) => {
    setIsLoading(true)

    try {
      const resp = await instance.post(
        endpoint,
        { ...formData, ...extraData },
        { params: { ...formData, ...extraData } }
      )
      const {
        status,
        data: { success, message },
      } = resp
      if (status === 200 && success) {
        onSuccess(resp)
        setServerError('')
      } else {
        setServerError(message)
      }
    } catch (e: any) {
      const { message } = e.response.data
      setServerError(message)
    }
    setIsLoading(false)
  }
  return { onSubmit, isLoading, serverError }
}

export default useSubmit
